module.exports = __webpack_public_path__ + "assets/img/101409.4960d56a.svg";